import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-export-icon',
  templateUrl: './export-icon.component.html',
  styleUrls: ['./export-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExportIconComponent {
  @Input() customClass: string;
  @Input() downloading = false;
  @Input() tooltip = '';
  @Output() exportClick = new EventEmitter<void>();
  handleClick() {
    if (!this.downloading) {
      this.exportClick.emit();
    }
  }
}
